import React, { useState } from "react";

import "./Program.report.dialog.scss";
import Modal from "react-modal";
import { useLazyQuery } from "@apollo/client";
import gqlSchemaLibrary from "../../services/graphql.schemas";
import { useTranslation } from "react-i18next";
import moment from "moment";
import {ModalLog} from "../../services/interactions/elements/modal";
import AuditTrail, {PAGES} from "../../services/interactions/audit.trail";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "none",
    padding: "0px",
    boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.38)",
  },
};
Modal.setAppElement("#root");

const _Modal = ModalLog(Modal);

function AlertsReportDialog({ programId, programName, openModal, closeModal }) {
  const { t } = useTranslation(["common", "programs"]);
  const [__submitting, __setSubmitting] = useState(false);

  const closeModalEmpty = () => {
    closeModal();
  };

  const [getAlertsReport] = useLazyQuery(
    gqlSchemaLibrary.programs.query.getAlertsReport,
    {
      onCompleted: (getAlertsReport) => {
        const file = getAlertsReport.getAlertsReport;
        if (file) {
          AuditTrail.sendLog(PAGES.PROGRAM_DETAIL, {event: 'onClick', action: 'button download alerts report success', program_id: programId});
          downloadFile(file.name, file.data);
          closeModal();
        }
        __setSubmitting(false);
      },
      onError: () => {
        AuditTrail.sendLog(PAGES.PROGRAM_DETAIL, {event: 'onClick', action: 'button download alerts report error', program_id: programId});
        __setSubmitting(false);
      },
      fetchPolicy: "cache-and-network",
    }
  );

  const downloadFile = (name, data) => {
    const linkSource = `data:text/csv;base64,${data}`;
    let downloadLink = document.createElement("a");
    const fileName = name;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
    downloadLink = null;
  };

  const onDownload = () => {
    if (__submitting) {
      return;
    }
    AuditTrail.sendLog(PAGES.PROGRAM_DETAIL, {event: 'onClick', action: 'button download alerts report', program_id: programId});
    __setSubmitting(true);

    getAlertsReport({
      variables: {
        id: programId,
      },
    });
  };

  return (
    <_Modal
      isOpen={!!openModal}
      style={customStyles}
      onRequestClose={closeModalEmpty}
      contentLabel="Alerts Summary"
      label="Alerts Summary Download Report"
      event={PAGES.PROGRAM_DETAIL}
      eventParams={{program_id: programId}}
    >
      <div id="ProgramReportDialog">
        <div className="__MembersTitle">
          <i className="material-icons" onClick={closeModalEmpty}>
            arrow_back_ios
          </i>
          <h3>{t("programs:alerts-summary") + " " + programName}</h3>
        </div>
        <div className="__Container">
          <p className="justify">
            {t("programs:alerts-modal-text") +
              " " +
              moment().format("MMMM Do YYYY, h:mm:ss a")}
          </p>
          <div className="containerButtons">
            <button className="primary gray" onClick={closeModalEmpty}>
              {t("cancel")}
            </button>
            <button
              disabled={false}
              className="primary blue"
              onClick={onDownload}
            >
              {t("download")}
            </button>
          </div>
        </div>
      </div>
    </_Modal>
  );
}

export default AlertsReportDialog;
